import React, { useState } from 'react';
import styled from 'styled-components';
import { COLORS } from '../../Styles/Colors';
import { Company } from '../../Types';

interface BulkImportProps {
    onImportComplete: (importedCompanies: Company[]) => void;
    onError: (errorMsg: string) => void;

  }

const ImportContainer = styled.div`
  padding: 20px;
`;

const FileInput = styled.input`
  margin-bottom: 15px;
`;

const Button = styled.button`
  padding: 8px 16px;
  background-color: ${COLORS.teal};
  color: ${COLORS.white};
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: ${COLORS.darkTeal};
  }
`;

const ImportWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const ImportContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 80%;
  max-width: 500px;
`;

const InstructionText = styled.p`
  color: ${COLORS.darkGray};
  font-size: 1em;
  text-align: center;
  line-height: 1.5;
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
`;


const StyledFileInput = styled.input`
  padding: 12px;
  font-size: 1em;
  border: 1px solid ${COLORS.gray};
  border-radius: 6px;
  background-color: ${COLORS.white};
  cursor: pointer;
  &:hover {
    border-color: ${COLORS.teal};
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 25px;
`;

const SubmitButton = styled.button`
  padding: 12px 25px;
  background-color: ${COLORS.teal};
  color: ${COLORS.white};
  border: none;
  border-radius: 6px;
  font-size: 1em;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    background-color: ${COLORS.darkTeal};
    transform: translateY(-2px);
  }
`;



const BulkImportCompany: React.FC<BulkImportProps> = ({ onImportComplete, onError }) => {
  const [file, setFile] = useState<File | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!file) {
      onError('Please select a file to import');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch('http://localhost:3000/api/company/import', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to import company');
      }

      const importedCompanies: Company[] = await response.json();
      onImportComplete(importedCompanies);
    } catch (err: any) {
      onError(err.message);
    }
  };

  return (
        <ImportWrapper>
          <ImportContent>
            <InstructionText>
              Please upload an Excel file (.xlsx) containing company information.
              The file should include columns for: Name, Serial Number (optional),
              Service Interval (optional), and Last Service Date (optional).
            </InstructionText>
            <InputGroup>
              <StyledFileInput type="file" accept=".xlsx" onChange={handleFileChange} />
            </InputGroup>
            <ButtonGroup>
              <SubmitButton type="button" onClick={handleSubmit}>Import Company Data</SubmitButton>
            </ButtonGroup>
          </ImportContent>
        </ImportWrapper>
      
  );
};

export default BulkImportCompany;